export default __webpack_public_path__ + "static/media/mastercard.0eb158f2.svg";